<template>
  <div class="logo-wrap">
    <img class="logo-entrance" :src="entranceLogoImageUrl" />
    <h3 class="center tit-h5">{{ title }}</h3>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { storeToRefs } from 'pinia';

import { useCallStore } from '@/stores/call';

const callStore = useCallStore();
const { qrCodeInfo } = storeToRefs(callStore);

const title = computed(() => qrCodeInfo.value?.title ?? 'SCON AI');
const entranceLogoImageUrl = computed(() =>
  qrCodeInfo.value?.entranceLogoImageUrl
    ? qrCodeInfo.value.entranceLogoImageUrl
    : 'https://sconchat.blob.core.windows.net/sconchat/static/images/logo-sconai.png'
);
</script>

<style scoped lang="scss">
.logo-wrap {
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  display: flex;
  position: relative;
  align-self: stretch;
  width: 100%;
  gap: 0.5rem;
  flex: 0 0 auto;
}

.logo-entrance {
  position: relative;
  width: 4rem;
  height: 4rem;
  border-radius: 20px;
  object-fit: contain;
}
</style>
